import { render } from "./await-verification.vue?vue&type=template&id=61df4efc"
import script from "./await-verification.vue?vue&type=script&lang=js"
export * from "./await-verification.vue?vue&type=script&lang=js"

import "./await-verification.vue?vue&type=style&index=0&id=61df4efc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__